import ProductsAndServicesLinks from './products-and-services-links.vue';
import MenuDrop from '../components/menu-drop.vue';
export default {
  components: {
    ProductsAndServicesLinks,
    MenuDrop
  }
};